export const trackGAEvent = (eventType, eventPayload) => {
    const cookieConsent = parseInt(window.localStorage.getItem('fai-cookie-consent'), 10)

    if (typeof window !== 'undefined' && cookieConsent > 0) {
        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
            event: eventType,
            payload: eventPayload,
        })
    }
}

export const deleteCookies = () => {
    const cookies = window.document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i]
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        window.document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
}



// WEBPACK FOOTER //
// ./src/components/utilities/tracking.js